import React, { Component } from 'react'
import resumeData from '../resumeData'
export interface State {
}

export interface Props {
}
export class Courses extends Component<Props, State> {

    constructor(props: Props) {
        super(props)
        this.state = {
        }
    }
    componentDidMount() {
    }


    cardContainer = () => {
        // flex flex-wrap justify-center gap-x-2
        return (
            <div className='courses__container__cards'>
                {resumeData.courses && resumeData.courses.map((item, index) => {
                    return (
                        <div className='wrapper' key={index}>
                            <div className='single-card' 
                                data-aos="flip-up"
                                data-aos-duration="1000">
                                <div className='front'>
                                    <img src={`${item.imgurl}`} className='item-img' id='thumbnail' loading='lazy' alt='course' />
                                </div>
                                {/* <div className='back' style={{ backgroundColor: color[index] }}> */}
                                <div className='back'>
                                    <div className='content'>
                                        <h2 className='heading-body-white'>{item.courseName}</h2>
                                        <div className='white-divider'></div>
                                        <div className='content-skills'> {item.skills?.map((skill, index) => {
                                            return (<h4 className='heading-body-white' key={index}>{skill} &ensp;</h4>)
                                        })}</div>
                                    </div>
                                </div>
                            </div>
                        </div>)
                })}
            </div>
        )
    }
    render() {
        return (
            <section id='courses' className='courses'>
                
                <div className="courses__container">
                    <div className="courses__container-header u-margin-left-medium u-margin-top-small"><span className="heading-title">Courses</span></div>
                    <div className="courses__container-body">
                        {this.cardContainer()}
                    </div>

                </div>
            </section >

        )
    }
}

export default Courses